import React from 'react';
import { Badge } from '../components/ui/badge';
import { marketingUrl } from '../lib/marketingUrls';
import { FileText } from 'lucide-react';

export default function ApiReference() {
  return (
    <section className="space-y-4 pb-8">
      <h1>API Reference</h1>
      <p className="text-muted-foreground">
        This page provides comprehensive documentation for the mySign.az API. Get the full PDF documentation{" "}
        <a href="/api-documentation.pdf" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-primary hover:underline">
          <FileText className="h-4 w-4" /> here
        </a>.
      </p>
      <pre className="overflow-auto rounded-lg border bg-background p-4 text-sm">{`X-API-KEY: "api secret"\nX-CLIENT-NAME: "client name"`}</pre>

      <h2 className="pt-2 text-2xl font-semibold">API Endpoints</h2>
      <div className="space-y-4">
        <div className="rounded-lg border p-4">
          <div className="mb-2 flex items-center gap-2"><Badge>POST</Badge><h3 className="font-semibold">/Document/Create</h3></div>
          <p className="text-sm text-muted-foreground">Creates a new document in the resource organisation system.</p>
        </div>
        <div className="rounded-lg border p-4">
          <div className="mb-2 flex items-center gap-2"><Badge variant="success">GET</Badge><h3 className="font-semibold">/Document/{'{id}'}</h3></div>
          <p className="text-sm text-muted-foreground">Retrieves details of an individual document by its unique identifier.</p>
        </div>
        <div className="rounded-lg border p-4">
          <div className="mb-2 flex items-center gap-2"><Badge variant="success">GET</Badge><h3 className="font-semibold">/Documents</h3></div>
          <p className="text-sm text-muted-foreground">Retrieves a list of all documents accessible to the authenticated client.</p>
        </div>
      </div>

      <h3 className="pt-2 text-xl font-semibold">Need Help?</h3>
      <p className="text-muted-foreground">
        For additional support or questions about API integration, please{" "}
        <a href={marketingUrl('/contact')} className="text-primary hover:underline">contact our support team</a>.
      </p>
    </section>
  );
}

